// extracted by mini-css-extract-plugin
export default {"titlePage":"databaseDefault_titlePage__f-Elc"};